/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
// import produce from 'immer'
import {ceil} from 'utils/number'

/* const getEntitiesWithUserInput = (d, {
  symbol, type, orderQty, price
}) =>
  produce(d, draftState => {
    draftState[symbol] = draftState[symbol] || {askNotional: 0, bidNotional: 0}
    draftState[symbol][`${type}Notional`] = Number(draftState[symbol][`${type}Notional`] || 0) + orderQty * price
  }) */

const table = [
  {
    bracket_seq: 1,
    bracket_notional_floor: 0,
    bracket_notional_cap: 50000,
    bracket_initial_margin_rate: 0.008,
    bracket_maintenance_margin_rate: 0.004,
    cum_fast_maintenance_amount: 0,
    maxLeverage: 125,
  },
  {
    bracket_seq: 2,
    bracket_notional_floor: 50000,
    bracket_notional_cap: 250000,
    bracket_initial_margin_rate: 0.01,
    bracket_maintenance_margin_rate: 0.005,
    cum_fast_maintenance_amount: 50,
    maxLeverage: 100,
  },
  {
    bracket_seq: 3,
    bracket_notional_floor: 250000,
    bracket_notional_cap: 1000000,
    bracket_initial_margin_rate: 0.02,
    bracket_maintenance_margin_rate: 0.01,
    cum_fast_maintenance_amount: 1300,
    maxLeverage: 50,
  },
  {
    bracket_seq: 4,
    bracket_notional_floor: 1000000,
    bracket_notional_cap: 5000000,
    bracket_initial_margin_rate: 0.05,
    bracket_maintenance_margin_rate: 0.025,
    cum_fast_maintenance_amount: 16300,
    maxLeverage: 20,
  },
  {
    bracket_seq: 5,
    bracket_notional_floor: 5000000,
    bracket_notional_cap: 10000000,
    bracket_initial_margin_rate: 0.1,
    bracket_maintenance_margin_rate: 0.05,
    cum_fast_maintenance_amount: 141300,
    maxLeverage: 10,
  },
  {
    bracket_seq: 6,
    bracket_notional_floor: 10000000,
    bracket_notional_cap: 20000000,
    bracket_initial_margin_rate: 0.125,
    bracket_maintenance_margin_rate: 0.1,
    cum_fast_maintenance_amount: 641300,
    maxLeverage: 5,
  },
  {
    bracket_seq: 7,
    bracket_notional_floor: 20000000,
    bracket_notional_cap: 35000000,
    bracket_initial_margin_rate: 0.2,
    bracket_maintenance_margin_rate: 0.125,
    cum_fast_maintenance_amount: 1141300,
    maxLeverage: 4,
  },
  {
    bracket_seq: 8,
    bracket_notional_floor: 35000000,
    bracket_notional_cap: 50000000,
    bracket_initial_margin_rate: 0.25,
    bracket_maintenance_margin_rate: 0.15,
    cum_fast_maintenance_amount: 2016300,
    maxLeverage: 3,
  },
  {
    bracket_seq: 9,
    bracket_notional_floor: 50000000,
    bracket_notional_cap: 99999999999,
    bracket_initial_margin_rate: 0.3,
    bracket_maintenance_margin_rate: 0.25,
    cum_fast_maintenance_amount: 7016300,
    maxLeverage: 2,
  },
]

export const calculateViewData = (positions = {}, balance = 0, leverage) => {
  const [totalUnrealizedPnl, totalPositionNotionalValue] = accumulatorFn(positions)
  // Step 1
  const positionList = Object.keys(positions).map(key => {
    const orderItem = {}
    const curPosition = positions[key]
    orderItem.unrealizedPnl = unrealizedPnlFn(curPosition)
    orderItem.positionNotionalValue = positionNotionalValueFn(curPosition)
    orderItem.initialMarginNotional = initialMarginNotionalFn(curPosition)
    orderItem.liquidationPrice = liquidationPriceFn(
      Number(totalPositionNotionalValue),
      Number(balance),
      Number(curPosition.positionSize),
      Number(curPosition.entryPrice)
    )
    return {...curPosition, ...orderItem}
  })
  // Step 2
  const {
    totalMarginBalance, // 29
    totalMaintenanceMargin, // 30
    totalInitialMargin,
    availableBalance // 38
  } = positionFn(positions, balance, leverage)

  const balanceData = {
    totalInitialMargin,
    totalMarginBalance,
    totalUnrealizedPnl,
    totalMaintenanceMargin,
    availableBalance,
    walletBalance: balance || 0,
    markLevel: totalMaintenanceMargin / totalMarginBalance
  }

  return {positionList, balanceData}
}

const fromTableWithValue = value => {
  let idx = 0
  while (idx < table.length) {
    const row = table[idx]
    if (value < row.bracket_notional_cap) {
      return row
    }
    idx += 1
  }
  return idx && table[idx - 1]
}

export const unrealizedPnlFn = ({positionSize, entryPrice, markPrice}) =>
  positionSize * (markPrice - entryPrice) || 0

export const positionNotionalValueFn = ({positionSize, markPrice}) => {
  const contractMultipler = 1
  return Math.abs(positionSize * contractMultipler * markPrice)
}

export const positionROEValueFn = ({
  positionSize, entryPrice, markPrice, leverage
}) => {
  const unrealizedPnl = Number(unrealizedPnlFn({positionSize, entryPrice, markPrice}))
  const positionNotional = positionNotionalValueFn({positionSize, markPrice: entryPrice})
  return `${((unrealizedPnl / (positionNotional * initialMarginMultiplyFn(leverage))) * 100).toFixed(2)}%`
}

export const initialMarginNotionalFn = ({
  bidNotional, askNotional, markPrice, positionSize
}) => {
  const notionalValue = markPrice * positionSize || 0
  bidNotional = Number(bidNotional || 0)
  askNotional = Number(askNotional || 0)
  return Math.max(Math.abs(notionalValue + bidNotional), Math.abs(notionalValue - askNotional))
}

export const accumulatorFn = products =>
  Object.keys(products).reduce(
    ([acc1, acc2, acc3], k) => {
      const d = products[k]
      acc1 += unrealizedPnlFn(d)
      const positionNotionalValue = positionNotionalValueFn(d)
      acc2 += positionNotionalValue
      acc3 = initialMarginNotionalFn(d, positionNotionalValue)
      return [acc1, acc2, acc3]
    },
    [0, 0, 0]
  )

export const totalInitialMarginFn = (_totalInitialMarginNotional, leverage) => {
  const totalInitialMargin = _totalInitialMarginNotional * initialMarginMultiplyFn(leverage)
  return totalInitialMargin
}

const totalMaintenanceMarginFn = totalPositionNotionalValue => {
  const {
    bracket_maintenance_margin_rate: rate,
    cum_fast_maintenance_amount: cum
  } = fromTableWithValue(totalPositionNotionalValue)
  const _totalMaintenanceMargin = totalPositionNotionalValue * rate - cum
  return _totalMaintenanceMargin
}

export const positionFn = (entities, walletBalance, leverage) => {
  const [
    totalUnrealizedPnl,
    totalPositionNotionalValue,
    totalInitialMarginNotional
  ] = accumulatorFn(entities)

  const totalMarginBalance = Number(totalUnrealizedPnl) + Number(walletBalance)
  const totalMaintenanceMargin = totalMaintenanceMarginFn(totalPositionNotionalValue)
  const totalInitialMargin = totalInitialMarginFn(totalInitialMarginNotional, leverage)
  const availableBalance = totalMarginBalance - totalInitialMargin
  return {
    totalMarginBalance, // 29
    totalUnrealizedPnl, // 28
    totalMaintenanceMargin, // 30
    totalInitialMargin,
    availableBalance // 38
  }
}

export const calculateAssumePrice = ({
  formType, type, askPrice, bidPrice, iptPrice, markPrice
}) => {
  askPrice = Number(askPrice)
  bidPrice = Number(bidPrice)
  iptPrice = Number(iptPrice)
  markPrice = Number(markPrice)
  const isBuy = type === 'bid'
  let calcPrice
  if (formType === 'market') {
    calcPrice = isBuy ? askPrice * (1 + 0.05) : Math.max(markPrice, bidPrice)
  } else {
    calcPrice = isBuy ? iptPrice : Math.max(bidPrice, markPrice, iptPrice)
  }
  return calcPrice
}

// entities {
//   USDTBTC: {
//   },
//   ...
// }
// symbol: 'USDTBTC'
// type: 'ask'/'bid'
// price, orderQty
// totalInitialMargin
export const marginRequiredFn = ({
  entities, symbol, type, orderQty, price, bidPrice, askPrice, formType, leverage
}) => {
  if (!orderQty) return 0
  const iptQty = Number(orderQty)
  const iptPrice = Number(price)
  const markPrice = Number(entities?.[symbol]?.markPrice) || 0
  const isBuy = type === 'bid'
  bidPrice = Number(bidPrice) || 0
  askPrice = Number(askPrice) || 0
  const calcPrice = calculateAssumePrice({
    formType, type, askPrice, bidPrice, iptPrice, markPrice
  })
  // if (formType === 'market') {
  //   calcPrice = isBuy ? askPrice * (1 + 0.05) : Math.max(markPrice, bidPrice)
  // } else {
  //   calcPrice = isBuy ? iptPrice : Math.max(bidPrice, markPrice, iptPrice)
  // }
  const {bidNotional, askNotional, positionSize} = entities?.[symbol] || {}
  const initNotionalObj = {
    bidNotional, askNotional, positionSize, markPrice
  }
  const newNotional = calcPrice * 1 * iptQty
  const _initMarginNotional = initialMarginNotionalFn(initNotionalObj)
  const _afterMarginNotional = initialMarginNotionalFn(
    isBuy ? {...initNotionalObj, bidNotional: Number(bidNotional) + newNotional}
      : {...initNotionalObj, askNotional: Number(askNotional) + newNotional}
  )
  const _marginRequired = (Number(_afterMarginNotional) - Number(_initMarginNotional)) * initialMarginMultiplyFn(leverage)
  return Math.max(_marginRequired, 0)
}

export const liquidationPriceFn = (
  totalPositionNotionalValue,
  walletBalance,
  positionSize,
  entryPrice
) => {
  let idx = table.length - 1
  let liquidationPrice

  while (idx >= 0) {
    const {
      bracket_maintenance_margin_rate: rate,
      cum_fast_maintenance_amount: cum,
      bracket_notional_floor,
      bracket_notional_cap
    } = table[idx]

    liquidationPrice = (walletBalance + cum - positionSize * entryPrice)
      / (Math.abs(positionSize) * rate - positionSize)
    const liquidationNotional = liquidationPrice * Math.abs(positionSize)
    if (
      liquidationNotional >= bracket_notional_floor
      && liquidationNotional <= bracket_notional_cap
    ) {
      break
    }
    idx -= 1
  }
  return liquidationPrice
}

export const initialMarginMultiplyFn = leverage => ceil(1 / leverage, 4) * 1

export const userCurLeverageFn = totalPositionNotionalValue => fromTableWithValue(totalPositionNotionalValue)
export const findCurLeverageByLevel = value => {
  let idx = 0
  const tempTable = [...table].reverse()
  while (idx < tempTable.length) {
    const row = tempTable[idx]
    const val = row.maxLeverage
    if (value === val) {
      return value === 2 ? tempTable[idx + 1] : row
    }
    if (value < val) {
      return tempTable[Math.max(idx, 0)]
    }
    idx += 1
  }
  return idx && tempTable[idx - 1]
}
